import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addComplaintComment, type AddCommentRequest, type ComplaintHistoryEvent } from '../api';

/**
 * Hook for adding comments to complaints
 * Works for both internal users and vendors
 * @param complaintId - The complaint ID to add a comment to
 */
export function useAddComment(complaintId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AddCommentRequest): Promise<{ status: boolean; data: ComplaintHistoryEvent }> =>
      addComplaintComment(complaintId, data),
    onSuccess: () => {
      // Invalidate detail query to show new comment in history
      queryClient.invalidateQueries({ queryKey: ['complaint', complaintId] });
    },
  });
}
